import React, { useState } from "react";
import Alert from "../../../controls/Alert";

const TriplegNotesValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  if (!error && !record.diversionCategory) {
    error = true;
    errorMessage = "A 'Category' is required";
  }
  if (!error && !record.divertedToAirport) {
    error = true;
    errorMessage = "A 'Diverted to Airport' is required";
  }
  if (!error && !record.noteText) {
    error = true;
    errorMessage = "A 'Diversion Reason' is required";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default TriplegNotesValidator;
